/**
 * Deep key-sorts a value so JSON.stringify is independent of property
 * insertion order — two structurally identical objects built in different
 * orders must hash the same.
 */
function sortKeysDeep(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortKeysDeep)
  if (value && typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>)
      .sort()
      .reduce<Record<string, unknown>>((acc, key) => {
        acc[key] = sortKeysDeep((value as Record<string, unknown>)[key])
        return acc
      }, {})
  }
  return value
}

/** 32-bit FNV-1a hash, base36-encoded. Not cryptographic — a cheap, synchronous consistency check, not a security mechanism. */
function fnv1a(text: string): string {
  let hash = 0x811c9dc5
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193)
  }
  return (hash >>> 0).toString(36)
}

/**
 * Hashes a game state value (e.g. `{ G, ctx }`) so independently-computed
 * clients can compare whether they agree on it without transmitting the
 * full state — used to detect replay divergence across clients.
 */
export function hashGameState(value: unknown): string {
  return fnv1a(JSON.stringify(sortKeysDeep(value)))
}
